var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("path",{"d":"M15.085 10.4l-3.137-1.392a1.542 1.542 0 00-1.824.442l-.947 1.185a12.427 12.427 0 01-3.813-3.812l1.184-.946a1.54 1.54 0 00.444-1.826L5.6.914A1.536 1.536 0 003.807.05L1.155.739a1.543 1.543 0 00-1.14 1.705 15.975 15.975 0 0013.541 13.541 1.5 1.5 0 00.212.015 1.544 1.544 0 001.493-1.154l.688-2.653a1.532 1.532 0 00-.864-1.793z","fill":"#53647f","data-name":"Layer 1"})));
}

Phone.defaultProps = {"width":"16","height":"16"};

module.exports = Phone;

Phone.default = Phone;
